import AppStore from "./AppStore";
import { buildClassName } from "./util";

// id: "1c9e7793-519b-4a2a-a0e4-a47cb1856e85"
// title: "Footer"
// type: :html
// key: "default-footer"
// parent_id: nil
export function DefaultFooter1c9e7793519b4a2aA0e4A47cb1856e85(props: any) {
  const Navigation = AppStore.presets["Navigation"];
  const Logo = AppStore.presets["Logo"];
  const GroupCopyright = AppStore.presets["GroupCopyright"];
  const GroupFlowTag = AppStore.presets["GroupFlowTag"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <footer className={`${parentTag || ""} DefaultFooter1c9e7793519b4a2aA0e4A47cb1856e85 footer`}>
      {props["links"] || <Navigation className="LinksF4f315c7A95540ad92fdC44a252e616d" parentTag={buildClassName("LinksF4f315c7A95540ad92fdC44a252e616d", parentTag)} navMenuSlug="footer-nav" {...props} />}
      <div className="logo-wrapper">
        {props["logo"] || <Logo className="Logo073e569a77274ed389c2E1a9cd7d305c" parentTag={buildClassName("Logo073e569a77274ed389c2E1a9cd7d305c", parentTag)} logoType="FOOTER" contentSlug="footer-logo" {...props} />}
      </div>
      {props["copyright"] || <GroupCopyright className="CopyrightBbe99231554a4ff4B702544a05e3bbd2" parentTag={buildClassName("CopyrightBbe99231554a4ff4B702544a05e3bbd2", parentTag)} {...props} />}
      {props["groupflow"] || <GroupFlowTag className="GroupflowCe99c3326d574d7eB99d383e1564c65f" parentTag={buildClassName("GroupflowCe99c3326d574d7eB99d383e1564c65f", parentTag)} {...props} />}
    </footer>
  );
}

// id: "073e569a-7727-4ed3-89c2-e1a9cd7d305c"
// title: ""
// type: :gf_preset
// key: "logo"
// parent_id: "1c9e7793-519b-4a2a-a0e4-a47cb1856e85"
export function Logo073e569a77274ed389c2E1a9cd7d305c(props: any) {
  const Logo = AppStore.presets["Logo"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Logo className="Logo073e569a77274ed389c2E1a9cd7d305c" parentTag={buildClassName("Logo073e569a77274ed389c2E1a9cd7d305c", parentTag)} logoType="FOOTER" contentSlug="footer-logo" {...props} />
  );
}

// id: "bbe99231-554a-4ff4-b702-544a05e3bbd2"
// title: ""
// type: :gf_preset
// key: "copyright"
// parent_id: "1c9e7793-519b-4a2a-a0e4-a47cb1856e85"
export function CopyrightBbe99231554a4ff4B702544a05e3bbd2(props: any) {
  const GroupCopyright = AppStore.presets["GroupCopyright"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <GroupCopyright className="CopyrightBbe99231554a4ff4B702544a05e3bbd2" parentTag={buildClassName("CopyrightBbe99231554a4ff4B702544a05e3bbd2", parentTag)} {...props} />
  );
}

// id: "f4f315c7-a955-40ad-92fd-c44a252e616d"
// title: ""
// type: :gf_preset
// key: "links"
// parent_id: "1c9e7793-519b-4a2a-a0e4-a47cb1856e85"
export function LinksF4f315c7A95540ad92fdC44a252e616d(props: any) {
  const Navigation = AppStore.presets["Navigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Navigation className="LinksF4f315c7A95540ad92fdC44a252e616d" parentTag={buildClassName("LinksF4f315c7A95540ad92fdC44a252e616d", parentTag)} navMenuSlug="footer-nav" {...props} />
  );
}

// id: "ce99c332-6d57-4d7e-b99d-383e1564c65f"
// title: ""
// type: :gf_preset
// key: "groupflow"
// parent_id: "1c9e7793-519b-4a2a-a0e4-a47cb1856e85"
export function GroupflowCe99c3326d574d7eB99d383e1564c65f(props: any) {
  const GroupFlowTag = AppStore.presets["GroupFlowTag"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <GroupFlowTag className="GroupflowCe99c3326d574d7eB99d383e1564c65f" parentTag={buildClassName("GroupflowCe99c3326d574d7eB99d383e1564c65f", parentTag)} {...props} />
  );
}

// id: "177e0b52-5d95-43b8-953f-94af83040862"
// title: ""
// type: :text
// key: "logoType"
// parent_id: "073e569a-7727-4ed3-89c2-e1a9cd7d305c"
export const LogoType177e0b525d9543b8953f94af83040862 = "FOOTER";

// id: "ca26ff6b-3c36-4ab6-ae7b-d2dd2bd26908"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "f4f315c7-a955-40ad-92fd-c44a252e616d"
export const NavMenuSlugCa26ff6b3c364ab6Ae7bD2dd2bd26908 = "footer-nav";

// id: "3d613900-7bdf-4f0e-8c6a-5ef1451206b8"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "073e569a-7727-4ed3-89c2-e1a9cd7d305c"
export const ContentSlug3d6139007bdf4f0e8c6a5ef1451206b8 = "footer-logo";

const Components = {
  DefaultFooter1c9e7793519b4a2aA0e4A47cb1856e85,
  Logo073e569a77274ed389c2E1a9cd7d305c,
  CopyrightBbe99231554a4ff4B702544a05e3bbd2,
  LinksF4f315c7A95540ad92fdC44a252e616d,
  GroupflowCe99c3326d574d7eB99d383e1564c65f,
  LogoType177e0b525d9543b8953f94af83040862,
  NavMenuSlugCa26ff6b3c364ab6Ae7bD2dd2bd26908,
  ContentSlug3d6139007bdf4f0e8c6a5ef1451206b8
}

export default Components;